import { quad } from '@rdf-esm/data-model';
export function tripleToQuad(graph) {
  return ({
    subject,
    predicate,
    object
  }) => {
    return quad(subject, predicate, object, graph);
  };
}